/**
 * Opens the theme cart drawer when third-party apps (e.g. Kaching Bundles)
 * add to cart and redirect to /cart, or add via Ajax without section HTML.
 */
(function () {
  const CART_PATH = (window.routes && window.routes.cart_url) || '/cart';
  let opening = false;

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function isCartUrl(url) {
    if (!url || typeof url !== 'string') return false;
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.pathname === CART_PATH || parsed.pathname === '/cart';
    } catch (e) {
      return url === '/cart' || url.startsWith('/cart?') || url.startsWith('/cart#');
    }
  }

  function requestHasSections(body) {
    if (!body) return false;
    if (body instanceof FormData) return body.has('sections');
    if (typeof body === 'string') return body.indexOf('sections') !== -1;
    if (typeof body === 'object' && typeof body.get === 'function') return body.has('sections');
    try {
      return JSON.stringify(body).indexOf('sections') !== -1;
    } catch (e) {
      return false;
    }
  }

  async function refreshAndOpenCart() {
    const cart = getCart();
    if (!cart || typeof cart.renderContents !== 'function' || opening) return false;

    opening = true;
    try {
      const sectionIds = cart
        .getSectionsToRender()
        .map((section) => section.id)
        .join(',');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}?sections=${sectionIds}`);
      if (!response.ok) return false;

      const sections = await response.json();
      cart.classList.remove('is-empty');
      const drawerInner = cart.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');
      cart.renderContents({ sections });
      return true;
    } catch (e) {
      console.error('app-cart-drawer-bridge:', e);
      return false;
    } finally {
      setTimeout(function () {
        opening = false;
      }, 500);
    }
  }

  function interceptCartNavigation(url) {
    if (!isCartUrl(url) || !getCart()) return false;
    refreshAndOpenCart();
    return true;
  }

  ['assign', 'replace'].forEach(function (method) {
    if (typeof window.location[method] !== 'function') return;
    const original = window.location[method].bind(window.location);
    window.location[method] = function (url) {
      if (interceptCartNavigation(String(url))) return;
      return original(url);
    };
  });

  try {
    const hrefDesc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
    if (hrefDesc && hrefDesc.set && hrefDesc.get) {
      Object.defineProperty(Location.prototype, 'href', {
        configurable: true,
        enumerable: true,
        get: function () {
          return hrefDesc.get.call(this);
        },
        set: function (url) {
          if (interceptCartNavigation(String(url))) return;
          hrefDesc.set.call(this, url);
        },
      });
    }
  } catch (e) {
    // Some browsers disallow patching Location.prototype.href
  }

  const originalFetch = window.fetch;
  window.fetch = function () {
    const args = arguments;
    const input = args[0];
    const init = args[1] || {};
    const requestUrl = typeof input === 'string' ? input : input && input.url;
    const isCartAdd = requestUrl && /\/cart\/add/i.test(requestUrl);
    const body = init.body || (input && input.body);
    const hasSections = requestHasSections(body);

    return originalFetch.apply(this, args).then(function (response) {
      if (isCartAdd && response.ok && !hasSections && getCart()) {
        setTimeout(refreshAndOpenCart, 50);
      }
      return response;
    });
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._appCartBridgeUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const xhr = this;
    const url = xhr._appCartBridgeUrl;
    const isCartAdd = url && /\/cart\/add/i.test(String(url));
    const hasSections = requestHasSections(body);

    if (isCartAdd && !hasSections) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300 && getCart()) {
          setTimeout(refreshAndOpenCart, 50);
        }
      });
    }

    return originalSend.apply(this, arguments);
  };
})();
